import React, { createContext, useContext, useState, useEffect } from 'react';

const CountryContext = createContext();

export const useCountry = () => {
  const context = useContext(CountryContext);
  if (!context) {
    throw new Error('useCountry must be used within a CountryProvider');
  }
  return context;
};

export const CountryProvider = ({ children }) => {
  const [country, setCountry] = useState(() => {
    // Load from localStorage on mount (for persistence across navigation)
    // But API calls are controlled by page navigation, not just country presence
    const savedCountry = localStorage.getItem('selectedCountry');
    return savedCountry || null;
  });
  const [availableCountries, setAvailableCountries] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Fetch available countries on mount
  useEffect(() => {
    const fetchAvailableCountries = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000'}/api/country/available`);
        const data = await response.json();
        if (data.success) {
          setAvailableCountries(data.countries);
          // Don't auto-select default country - user must explicitly choose
        }
      } catch (error) {
        console.error('Error fetching available countries:', error);
        // No fallback - countries must be available from S3
        setAvailableCountries([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAvailableCountries();
  }, []);

  const updateCountry = (newCountry) => {
    setCountry(newCountry);
    localStorage.setItem('selectedCountry', newCountry);
  };

  const value = {
    country,
    availableCountries,
    updateCountry,
    isLoading
  };

  return (
    <CountryContext.Provider value={value}>
      {children}
    </CountryContext.Provider>
  );
};

